import React from 'react';
import { Accessibility, Armchair, Bookmark, BookUser, CalendarDays, ClipboardList, ClipboardPlus, Contact, FileSpreadsheet, FolderSync, HeartHandshake, Home, ListFilter, LockKeyhole, Repeat2, Search, Star, Stethoscope, Syringe, TestTubeDiagonal } from 'lucide-react';
import { useDocumentTitle } from '../../../hooks/customDocumentTitleHook';
import { Config } from '../../../Config';
import Spacing from '../../Spacing';
import BackBtn from '../../Button/BackBtn';
const maleAvatar = './images/avatar.png';
const femaleAvatar = './images/female.png';
const otherAvatar = './images/other.png';

const ICONS = {
  Accessibility: Accessibility,
  TestTubeDiagonal: TestTubeDiagonal,
  Syringe: Syringe,
  BookUser: BookUser,
  Armchair: Armchair,
  CalendarDays: CalendarDays,
  Contact: Contact,
  Stethoscope: Stethoscope,
  ClipboardPlus: ClipboardPlus,
  HeartHandshake: HeartHandshake,
  Repeat2: Repeat2,
  FolderSync: FolderSync,
  Star: Star,
  ClipboardList: ClipboardList,
  FileSpreadsheet: FileSpreadsheet
};

export default function AuditProgressRunning(props) {
  const {
    icon = null,
    name = "",
    show_filter = false,
    show_back_btn = false,
    back_btn_link = "",
    back_btn_text = null
  } = props;

  const SelectedIcon = ICONS[icon] || Home;

  useDocumentTitle(`${name}`);

  return (
    <>
      {show_back_btn && (
        <>
          <BackBtn href={`${back_btn_link}`} btnText={`${back_btn_text}`} />
          <Spacing lg="0" sm="24" />
        </>
      )}

      <div className="docpro_page_heading_wrap">
        <h2 className="docpro_page_heading docpro_fs_24">
          <i
            className=" docpro_white_color"
            style={{ backgroundColor: "#369eff" }}
          >
            <SelectedIcon width={18} height={18} />
          </i>
          {name}
        </h2>
        <div className="docpro_page_heading_btns"></div>
      </div>

      <div className="docpro_data_table_wrap relative">
        <div className="docpro_data_table_headings">
          <form className="docpro_search_form width_100">
            <input
              type="text"
              placeholder="Search"
              className="docpro_search_input"
            />
            <button className="docpro_search_btn">
              <Search width={20} height={20} />
            </button>
          </form>

          <div className="docpro_data_table_btns p-0">
            {show_filter && (
              <>
                <button className="docpro_filter docpro_fw_500">
                  <Bookmark width={18} height={18} />
                  Saved filters
                </button>
                <button className="docpro_filter docpro_fw_500">
                  <ListFilter width={16} height={16} />
                  Filter
                </button>
              </>
            )}
          </div>
        </div>
        
        <div className="docpro_table_responsive" style={{ minHeight: "600px" }}>
          <table className="docpro_mb_0" style={{ height: "100%" }}>
            <thead>
              <tr>
                <th style={{ width: "45px" }}>
                  <div className="docpro_checkbox" style={{ top: "3px" }}>
                    <input type="checkbox" />
                    <label></label>
                  </div>
                </th>
                <th> Last Name </th>
                <th> First Name </th>
                <th> Date of Birth </th>
                <th> Gender </th>
                <th> Phone </th>
                <th> Insurance Name </th>
                <th> Last Visited </th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ width: "45px" }}>
                  <div className="docpro_checkbox" style={{ top: "3px" }}>
                    <input type="checkbox" />
                    <label></label>
                  </div>
                </td>
                <td>
                  <img
                    src={maleAvatar}
                    alt=""
                    width={28}
                    height={28}
                    style={{
                      marginRight: "10px",
                      objectFit: "cover",
                      borderRadius: "50%",
                    }}
                  />
                  <span className="audit_line small"></span>
                </td>
                <td>
                  <span className="audit_line"></span>
                </td>
                <td>
                  <span className="audit_line"></span>
                </td>
                <td>
                  <span className="audit_line"></span>
                </td>
                <td>
                  <span className="audit_line"></span>
                </td>
                <td>
                  <span className="audit_line small"></span>
                </td>
                <td>
                  <span className="audit_line"></span>
                </td>
                <td></td>
              </tr>
              <tr>
                <td style={{ width: "45px" }}>
                  <div className="docpro_checkbox" style={{ top: "3px" }}>
                    <input type="checkbox" />
                    <label></label>
                  </div>
                </td>
                <td>
                  <img
                    src={femaleAvatar}
                    alt=""
                    width={28}
                    height={28}
                    style={{
                      marginRight: "10px",
                      objectFit: "cover",
                      borderRadius: "50%",
                    }}
                  />
                  <span className="audit_line second  small"></span>
                </td>
                <td>
                  <span className="audit_line second "></span>
                </td>
                <td>
                  <span className="audit_line second "></span>
                </td>
                <td>
                  <span className="audit_line second "></span>
                </td>
                <td>
                  <span className="audit_line second "></span>
                </td>
                <td>
                  <span className="audit_line second  small"></span>
                </td>
                <td>
                  <span className="audit_line second "></span>
                </td>
                <td></td>
              </tr>
              <tr>
                <td style={{ width: "45px" }}>
                  <div className="docpro_checkbox" style={{ top: "3px" }}>
                    <input type="checkbox" />
                    <label></label>
                  </div>
                </td>
                <td>
                  <img
                    src={otherAvatar}
                    alt=""
                    width={28}
                    height={28}
                    style={{
                      marginRight: "10px",
                      objectFit: "cover",
                      borderRadius: "50%",
                    }}
                  />
                  <span className="audit_line third small"></span>
                </td>
                <td>
                  <span className="audit_line third"></span>
                </td>
                <td>
                  <span className="audit_line third"></span>
                </td>
                <td>
                  <span className="audit_line third"></span>
                </td>
                <td>
                  <span className="audit_line third"></span>
                </td>
                <td>
                  <span className="audit_line third small"></span>
                </td>
                <td>
                  <span className="audit_line third"></span>
                </td>
                <td></td>
              </tr>
            </tbody>
          </table>

          <div className="subscribe_lock_box">
            <div className="subscribe_lock">
              <LockKeyhole width={50} height={50} color='#369eff' />
              <Spacing lg="16" sm="16" />
              <p className="docpro_mb_0">
                Subscribe to {Config?._AppName}<br/>
                to access more data and insights.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
